import { render } from "./AddEdgeHost.vue?vue&type=template&id=1c73a64c"
import script from "./AddEdgeHost.vue?vue&type=script&lang=js"
export * from "./AddEdgeHost.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__